/**
 * Save Gmail Application Attachments To FTP
 * APi specification to save application attachments received in gmail to FTP
 *
 * OpenAPI spec version: 1.0.0
 * Contact: jimmy.nsenga@gmail.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Email } from './email';


export interface Request { 
    _id?: string;
    createdOn?: number;
    lastUpdatedOn?: number;
    emailSubject?: string;
    advertId?: string;
    emailRecipient?: string;
    receivedAfter?: number;
    receivedBefore?: number;
    numberMatchedEmails?: number;
    status?: Request.StatusEnum;
    emails?: Array<Email>;
    lastDownload?: number;
}
export namespace Request {
    export type StatusEnum = 'created' | 'ongoing' | 'done' | 'cancelled';
    export const StatusEnum = {
        Created: 'created' as StatusEnum,
        Ongoing: 'ongoing' as StatusEnum,
        Done: 'done' as StatusEnum,
        Cancelled: 'cancelled' as StatusEnum
    };
}
